export const SET_USERS = 'users/set_users'
export const SET_MY_PROFILE = 'users/set_my_profile'

const initialState = {
  profileUser: {},
  profile: {},
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS:
      return {
        ...state,
        profileUser: { ...state.profileUser, [action.payload._id]: action.payload },
      }
    case SET_MY_PROFILE:
      return {
        ...state,
        profile: action.payload,
      }

    default:
      return state
  }
}

export default reducer
